import { assignCommonProperties } from '../util/data/assign-common-properties.js'
import type { UserIdType } from '../types.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'
import { UserIdCtor } from '../user-id.js'

export const UserMfaMechanismTypes = ['phone', 'authenticator'] as const

@jsonClass('UserMfaMechanism')
export class UserMfaMechanism {
	@jsonProperty(Number)
	id?: number
	@jsonProperty(() => UserIdCtor)
	userId?: UserIdType
	@jsonProperty(String)
	name?: string
	@jsonProperty(String)
	type?: (typeof UserMfaMechanismTypes)[number]
	// used for phone number or authenticator secret
	@jsonProperty(String)
	authentication?: string

	// only used for SMS
	@jsonProperty(String)
	tokenIssued?: string

	@jsonProperty(Date)
	tokenValidUntil!: Date

	@jsonProperty(Date)
	creationDate?: Date
	@jsonProperty(Date)
	lastUsedDate?: Date

	constructor(init?: Partial<UserMfaMechanism>) {
		assignCommonProperties(this, init)
	}
}
